class NavCollection extends HTMLElement {
  constructor() {
    super();
    this.nav = this.querySelector('.js-nav-collection');
    this.list = this.querySelector('.js-nav-collection-list');
    this.buttons = this.querySelectorAll('.js-nav-collection-button');
    this.count = 1;
    if (this.list.offsetWidth >= this.nav.offsetWidth) {
      this.buttons.forEach((button) => {
        button.classList.remove('--hide');
        button.addEventListener('click', this.changeSlide.bind(this));
      })
    }
  }

  changeSlide(e) {
    e.preventDefault();
    e.stopPropagation();
    let button = e.target.closest('.js-nav-collection-button');
    let currentSlided = parseFloat(getComputedStyle(this.list).getPropertyValue('--slide'));
    if (button.classList.contains('--prev')) {
      if (this.count > 1) {
        let item = this.querySelector('.js-nav-collection-item:nth-child(' + (this.count - 1) + ')');
        let marginRight = parseFloat(window.getComputedStyle(item).marginRight);
        let slideSize = currentSlided + (item.offsetWidth + marginRight);
        this.list.style.setProperty('--slide', slideSize + 'px');
        this.count--;
      }
    } else {
      if (this.nav.getBoundingClientRect().right < this.list.getBoundingClientRect().right) {
        let item = this.querySelector('.js-nav-collection-item:nth-child(' + this.count + ')');
        let marginRight = parseFloat(window.getComputedStyle(item).marginRight);
        let slideSize = currentSlided - (item.offsetWidth + marginRight);
        this.list.style.setProperty('--slide', slideSize + 'px');
        this.count++;
      }
    }
  }
}

customElements.define('nav-collection', NavCollection);